'use strict';
const Signale = require('./signale');

module.exports = Object.assign(new Signale(), {Signale});
